import type { BenefitPledgeGeneration } from "@/lib/benefit-types"

export interface PledgeReportFlag {
  label: "Urgent" | "Called in" | "Updated"
  enabled: boolean
}

/**
 * Returns all independent flags so a false or omitted value is visible as "No" rather than
 * being mistaken for a flag that the report forgot to load.
 */
export function pledgeReportFlags(row: Partial<Pick<BenefitPledgeGeneration, "urgent" | "calledIn" | "updated">>): PledgeReportFlag[] {
  return [
    { label: "Urgent", enabled: row.urgent === true },
    { label: "Called in", enabled: row.calledIn === true },
    { label: "Updated", enabled: row.updated === true },
  ]
}

/**
 * Daily pledge rows are deserialized from the committed publication artifact. Removed follow-up
 * rows are read from the current instruction/removal model, so the UI must not present those
 * values as frozen publication flags.
 */
export function pledgeReportFlagSourceLabel(removed: boolean): "Published flags" | "Current flags" {
  return removed ? "Current flags" : "Published flags"
}
